import { get, post } from "../http";
import baseURL from "../base";

export default {

    // 检索接口
    search (data) {
        return post(`${baseURL.searchURL}article/search`, data);
    },
    sDetalis (data) {
        // 详情接口
        return get(`${baseURL.searchURL}article/detail?articleId=` + data);
    },
    //"article/,
    checkFiltrate (key, data) {
        // 详情接口
        return post(`${baseURL.searchURL}article/` + key + `?uuid=` + data);
    },

    // 学术检索接口
    xsSearch (data) {
        return get(`${baseURL.scholarURL}search`, data);
    },
    // 学术详情接口
    xsDetail (data) {
        return post(`${baseURL.scholarURL}detail`, data);
    },
    // 学术申请全文
    xsApply (data) {
        return post(`${baseURL.scholarURL}article/pretreat`, data);
    },
    enAddcase (data) {
        return post(`${baseURL.fullText}cases/add`, data);
    },
    // 学术相关链接
    xsVersion (data) {
        return post(`${baseURL.scholarURL}get-version`, data);
    },
    // 学术被引量
    xsCites (data) {
        return get(`${baseURL.scholarURL}cites`, data);
    },


    // 基金检索接口
    fundSearch (data) {
        return post(`${baseURL.xueshuURL}fund/search`, data);
    },
    // 基金筛选、分页接口
    fundSquery (data) {
        return post(`${baseURL.xueshuURL}fund/squery`, data);
    },
    // 基金筛选接口
    fundSearchaggs (data) {
        return post(`${baseURL.xueshuURL}fund/searchaggs`, data);
    },
};
